declare namespace $ {

	type $mol_view__sub_bog_ui_app_sheet_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sheet_3 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['open_top'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sheet_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sheet_5 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['open_right'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sheet_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sheet_7 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['open_bottom'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sheet_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_ui_app_sheet_9 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['open_left'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_app_sheet_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sheet__showed_bog_ui_app_sheet_15 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['top_showed'] >
		,
		ReturnType< $bog_ui_sheet['showed'] >
	>
	type $bog_ui_sheet__side_bog_ui_app_sheet_16 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sheet['side'] >
	>
	type $bog_ui_sheet__content_bog_ui_app_sheet_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sheet['content'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_bog_ui_app_sheet_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_ui_app_sheet_22 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['right_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_ui_app_sheet_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_ui_app_sheet_24 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['right_email'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sheet__showed_bog_ui_app_sheet_26 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['right_showed'] >
		,
		ReturnType< $bog_ui_sheet['showed'] >
	>
	type $bog_ui_sheet__side_bog_ui_app_sheet_27 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sheet['side'] >
	>
	type $bog_ui_sheet__content_bog_ui_app_sheet_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sheet['content'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sheet__showed_bog_ui_app_sheet_32 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['bottom_showed'] >
		,
		ReturnType< $bog_ui_sheet['showed'] >
	>
	type $bog_ui_sheet__side_bog_ui_app_sheet_33 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sheet['side'] >
	>
	type $bog_ui_sheet__content_bog_ui_app_sheet_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sheet['content'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_ui_app_sheet_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_ui_sheet__showed_bog_ui_app_sheet_38 = $mol_type_enforce<
		ReturnType< $bog_ui_app_sheet['left_showed'] >
		,
		ReturnType< $bog_ui_sheet['showed'] >
	>
	type $bog_ui_sheet__side_bog_ui_app_sheet_39 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_ui_sheet['side'] >
	>
	type $bog_ui_sheet__content_bog_ui_app_sheet_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_ui_sheet['content'] >
	>
	export class $bog_ui_app_sheet extends $mol_page {
		description( ): string
		Description( ): $mol_view
		buttons_title( ): string
		Buttons_title( ): $mol_view
		open_top( next?: any ): any
		top_label( ): string
		Top_button( ): $mol_button_minor
		open_right( next?: any ): any
		right_label( ): string
		Right_button( ): $mol_button_minor
		open_bottom( next?: any ): any
		bottom_label( ): string
		Bottom_button( ): $mol_button_minor
		open_left( next?: any ): any
		left_label( ): string
		Left_button( ): $mol_button_minor
		Buttons( ): $mol_view
		top_showed( next?: boolean ): boolean
		top_heading( ): string
		Top_heading( ): $mol_view
		top_text( ): string
		Top_text( ): $mol_view
		Top_content( ): $mol_view
		Sheet_top( ): $bog_ui_sheet
		right_showed( next?: boolean ): boolean
		right_heading( ): string
		Right_heading( ): $mol_view
		right_text( ): string
		Right_text( ): $mol_view
		right_form_title( ): string
		Right_form_title( ): $mol_view
		right_name( next?: string ): string
		Right_name( ): $mol_string
		right_email( next?: string ): string
		Right_email( ): $mol_string
		Right_content( ): $mol_view
		Sheet_right( ): $bog_ui_sheet
		bottom_showed( next?: boolean ): boolean
		bottom_heading( ): string
		Bottom_heading( ): $mol_view
		bottom_text( ): string
		Bottom_text( ): $mol_view
		Bottom_content( ): $mol_view
		Sheet_bottom( ): $bog_ui_sheet
		left_showed( next?: boolean ): boolean
		left_heading( ): string
		Left_heading( ): $mol_view
		left_text( ): string
		Left_text( ): $mol_view
		Left_content( ): $mol_view
		Sheet_left( ): $bog_ui_sheet
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=sheet.view.tree.d.ts.map